// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + ({"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] || chunkId) + "." + {"189":"11f6a85fed0ba0b75f33","404":"d8ae3a7e6bbc27eab89f","406":"be67065606a4aff2c752","769":"5f1eff186479d99c5eef"}[chunkId] + ".js";
};